/* eslint-disable max-len */

import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default ({ className }) => (
  <SvgIcon viewBox='0 0 8 5' className={className} style={{ height: 5, width: 8 }}>
    <path id='Контур_13645' data-name='Контур 13645' d='M2360.908,1120.023l3.5,3.692,3.5-3.692' transform='translate(2368.615 1124.215) rotate(180)' fill='none' stroke='#8a949f' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1'/>
  </SvgIcon>
);
